module.exports = new __parcel__URL__("repository.8c379835.svg").toString();